import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, DiskButtonWrapper, PanelContent, PanelFrame, PanelRightBlock, PanelRow } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import { AUTH_BONUS_REPEAT, AUTH_GA_POCKET, AUTH_SEND_REPEAT } from 'apps/auth/constants/UrlConstants';
import { getIconForDiskBadge } from 'apps/auth/helpers/historyUtils';
import { toLowerCase } from 'apps/auth/helpers/utils';

import DeleteRecipientPopup from '../recipientList/DeleteRecipientPopup';

const RecipientListItem = (props) => {
    const href = useMemo(() => {
        let recipientUrlParam = props.recipient?.extra.to_recipient_category_type ? `&type=${props.recipient?.extra?.to_recipient_category_type}` : '';
        if (props.recipient?.lastPaymentId > 0 && props.isBonus) {
            return `${AUTH_BONUS_REPEAT}?repeatId=${props.paymentId}&isBonusWithdraw=true${recipientUrlParam}`;
        } else if (props.recipient?.lastPaymentId > 0) {
            return props.pocketId
                ? `${AUTH_GA_POCKET}${props.pocketId}/send/gt/repeat/${props.paymentId}`
                : `${AUTH_SEND_REPEAT}?repeatId=${props.paymentId}&fromSend=true${recipientUrlParam}`;
        } else if (props.isBonus) {
            return `${AUTH_BONUS_REPEAT}?recipientId=${props.recipient?.id}&isBonusWithdraw=true${recipientUrlParam}`;
        } else {
            return props.pocketId
                ? `${AUTH_GA_POCKET}${props.pocketId}/send/gt/repeat/${props.recipient?.id}?isRecipientId=true`
                : `${AUTH_SEND_REPEAT}?recipientId=${props.recipient?.id}&fromSend=true${recipientUrlParam}`;
        }
    }, []);

    return (
        <Panel
            type="link"
            href={href}
            isHoverable
            negativeMargin
            onClick={(e) => {
                if (typeof props.clickHandler === 'function') {
                    props.clickHandler(e, props.recipient, href, props.isDisabledCountry, props.isBonus, props.toCountryName, props.providerToCategory);
                }
            }}
        >
            <PanelFrame>
                <DiskBadgeWrapper>
                    <DiskBadge iconName={getIconForDiskBadge({}, props.providerToCategory)} flagName={toLowerCase(props.toCountryCode)} />
                </DiskBadgeWrapper>
                <PanelContent>
                    <PanelRow>
                        <Text color="primary" ellipsis>
                            {props.leftTitle || props.leftSecondaryText}
                        </Text>
                    </PanelRow>
                    <PanelRow>
                        {props.leftTitle && (
                            <Text size="secondary" color={props.leftTitle ? 'secondary' : 'primary'} ellipsis>
                                {props.leftSecondaryText}
                            </Text>
                        )}
                    </PanelRow>
                </PanelContent>
                <PanelRightBlock>
                    <PanelRow>
                        <Text color="secondary" smallCaps>
                            {props.rightTitle}
                        </Text>
                    </PanelRow>
                    {props.rightIconName && (
                        <PanelRow>
                            <Icon name={props.rightIconName} size="16px" color={props.rightIconColor} leftIndent="8px" />
                        </PanelRow>
                    )}
                </PanelRightBlock>
                <DiskButtonWrapper marginLeft>
                    <DiskButton
                        type="button"
                        variant="error"
                        iconName="cross"
                        iconColor="error"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            props.popupRef.current?.open(<DeleteRecipientPopup popupRef={props.popupRef} recipient={props.recipient} />);
                        }}
                        raised={false}
                    />
                </DiskButtonWrapper>
            </PanelFrame>
        </Panel>
    );
};

RecipientListItem.propTypes = {
    iconLink: PropTypes.string,
    providerToCategory: PropTypes.number,
    pocketId: PropTypes.number,
    diskText: PropTypes.string,
    isDisabled: PropTypes.bool,
    leftTitle: PropTypes.string,
    leftSecondaryText: PropTypes.string,
    rightTitle: PropTypes.string,
    rightIconName: PropTypes.string,
    rightIconColor: PropTypes.string,
};

export default RecipientListItem;
